export const environment = {
  production: false,
  useEmulators: false,
  firebase : {
    apiKey: "AIzaSyDVPkYUhQvyaJLXEC7DySpra1UKTdEGZNI",
    authDomain: "narravero-eu-dev.firebaseapp.com",
    projectId: "narravero-eu-dev",
    storageBucket: "narravero-eu-dev.appspot.com",
    messagingSenderId: "700375310981",
    appId: "1:700375310981:web:550efb8b72d479523cbfec",
    measurementId: "G-21RMXY97DN"
  },
  appCheck: {
    recaptchaSiteKey: '6LcKzOMrAAAAANleJOhqkHnBAWwEQha3tzEOKnfg'
  },
  tagHostName:"https://nv2.at/",
  urlHostName:"api.narravero.dev"
  
};